import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getFormValues } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import Progress from 'components/common/Progress';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import Button from 'components/common/Button';

import { fetchEventLog, clearEventLog } from 'redux/modules/eventLog';

import * as validate from 'utils/validate';
import throttle from 'utils/throttle';
import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';
import activityLogEventTypes from 'config/activityLogEventTypes';

import EventLogViewTableHead from './EventLogViewTableHead';
import EventLogViewTableBody from './EventLogViewTableBody';
import EventLogViewFilterForm from './EventLogViewFilterForm';

class EventLogViewDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 10,
      offset: 0,
      triggerLoading: true,
      date: null,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onDialogEnter = this.onDialogEnter.bind(this);
    this.onDialogExited = this.onDialogExited.bind(this);
    this.onEventLogScrollFetchRequest = this.onEventLogScrollFetchRequest.bind(this);
    this.onRefreshButtonClick = this.onRefreshButtonClick.bind(this);

    this.onRequest = this.onRequest.bind(this);
    this.onThrottledRequest = throttle(this.onRequest, 1000, false, true);
  }

  componentWillReceiveProps(nextProps) {
    const { open, count, filters, loading } = this.props;
    const { limit, offset } = this.state;
    const newState = {};
    const filtersChanged = nextProps.filters['Date of Creation From'] !== filters['Date of Creation From']
      || nextProps.filters['Date of Creation To'] !== filters['Date of Creation To']
      || nextProps.filters['Date of Creation'] !== filters['Date of Creation']
      || nextProps.filters['User ID'] !== filters['User ID']
      || nextProps.filters.Event !== filters.Event
      || nextProps.filters['Order ID'] !== filters['Order ID'];
    if (filtersChanged) {
      newState.offset = 0;
    } else if (open
      && loading === 0
      && this.scrollbarsRef
      && this.scrollbarsRef.getScrollHeight() <= this.scrollbarsRef.getClientHeight()
      && (nextProps.eventLog.length - limit) >= offset) {
      newState.offset = offset + limit;
    }
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { open, filters } = this.props;
    const { limit, offset, date } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const dateChanged = prevState.date < date;
    const filtersChanged = prevProps.filters['User ID'] !== filters['User ID']
      || prevProps.filters.Event !== filters.Event;
    const throttledFiltersChanged = prevProps.filters['Date of Creation From'] !== filters['Date of Creation From']
      || prevProps.filters['Date of Creation To'] !== filters['Date of Creation To']
      || prevProps.filters['Date of Creation'] !== filters['Date of Creation']
      || prevProps.filters['Order ID'] !== filters['Order ID'];
    if (open) {
      if (throttledFiltersChanged) {
        this.onThrottledRequest();
      } else if (limitChanged || offsetChanged || dateChanged || filtersChanged) {
        this.onRequest();
      }
    }
  }

  onRequest() {
    const { actions, filters } = this.props;
    const { limit, offset, triggerLoading } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let operation;
        let caseSensitivity = null;
        let val = filters[key];
        switch (key) {
          case 'Date of Creation From':
            name = 'Date of Creation';
            operation = 'ge';
            break;
          case 'Date of Creation To':
            name = 'Date of Creation';
            operation = 'le';
            break;
          case 'Date of Creation':
            name = 'Date of Creation';
            operation = 'eq';
            break;
          case 'User ID':
          case 'Order ID':
          case 'Event':
            operation = 'eq';
            break;
          default:
            operation = 'startswith';
            caseSensitivity = false;
        }
        return {
          name,
          operation,
          val,
          ...caseSensitivity !== null ? { case_sensitivity: caseSensitivity } : {},
        };
      })
      : null;
    actions.fetchEventLog({
      limit,
      offset,
      filters: [
        {
          name: 'Record Number',
          operation: 'eq',
          val: this.props['Record Number'].toString(),
        },
        ...requestFilters ? [
          ...requestFilters,
        ] : [],
      ],
      triggerLoading: offset === 0,
      push: offset > 0,
    });
  }

  onDialogEnter() {
    this.props.actions.clearEventLog();
    this.setState({ date: moment().utc() });
  }

  onDialogExited() {
    this.setState({
      offset: 0,
      triggerLoading: true,
    });
  }

  onEventLogScrollFetchRequest() {
    const { offset, limit } = this.state;
    if ((this.props.eventLog.length - limit) >= offset) {
      this.setState({ offset: offset + limit });
    }
  }

  onRefreshButtonClick() {
    this.props.actions.clearEventLog();
    if (this.scrollbarsRef) {
      if (typeof this.scrollbarsRef.scrollTop === 'function') {
        this.scrollbarsRef.scrollTop(0);
      } else {
        this.scrollbarsRef.scrollTop = 0;
      }
    }
    if (this.state.offset === 0) {
      this.setState({
        triggerLoading: true,
        date: moment().utc(),
      });
    } else {
      this.setState({
        offset: 0,
        triggerLoading: true,
        date: moment().utc(),
      });
    }
  }

  render() {
    const {
      open,
      loading,
      onClose,
      eventLog,
      business,
    } = this.props;
    const { date } = this.state;
    const uniqueEventLog = eventLog.filter((item, index) => {
      if (item.Event === 'View' && item['Event Params'].Type === 'patient') {
        return eventLog.findIndex(findItem =>
          findItem.Event === 'View' && findItem['Event Params'].Type === 'patient'
          && findItem['Event Params']['Record Number'] === item['Event Params']['Record Number']
          && findItem['Create At'] === item['Create At']
          && findItem.User.ID === item.User.ID) === index;
      }
      return true;
    });
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEnter={this.onDialogEnter}
        onExited={this.onDialogExited}
        maxWidth="md"
      >
        <DialogTitle
          onCloseClick={onClose}
          secondaryContent={(
            <Fragment>
              <EventLogViewFilterForm
                form={`${this.props['Record Number']}-eventLog-filterForm`}
                disabled={loading > 0}
                {...this.props['Order ID'] ? {
                  initialValues: { 'Order ID': this.props['Order ID'].toString() },
                } : {}}
              />
              <EventLogViewTableHead
                date={date}
                business={business}
              />
            </Fragment>
          )}
        >
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            Activity Log
          </Typography>
        </DialogTitle>
        <DialogContent
          withScrollbars
          disableGutters
          scrollMaxHeightDecrease={150}
          fullHeight
          scrollbarsRef={(scrollbarsRef) => {
            this.scrollbarsRef = scrollbarsRef;
          }}
          onScrollFrame={(event) => {
            if (event.top > 0.8) {
              this.onEventLogScrollFetchRequest();
            }
          }}
        >      
          {(loading > 0) ? (
            <Progress />
          ) : (
            <EventLogViewTableBody
              eventLog={uniqueEventLog}
              business={business}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.onRefreshButtonClick}
            variant="raised"
          >
            Refresh
          </Button>
          <Button
            onClick={onClose}
            variant="raised"
            color="primary"
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

EventLogViewDialog.propTypes = {
  'Record Number': PropTypes.number.isRequired,
  eventLog: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchEventLog: PropTypes.func.isRequired,
    clearEventLog: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
};

EventLogViewDialog.defaultProps = {
  open: false,
  onClose: () => {},
  business: {},
};

const mapStateToProps = (store, ownProps) => {
  const filterFormValues = getFormValues(`${ownProps['Record Number']}-eventLog-filterForm`)(store);
  return {
    eventLog: store.eventLog.data,
    count: store.eventLog.count,
    loading: store.eventLog.loading,
    filters: {
      ...filterFormValues
        && filterFormValues['Date From']
        && !validate.date(filterFormValues['Date From'])
        && filterFormValues['Date From'] !== filterFormValues['Date To']
        ? {
          'Date of Creation From': moment(filterFormValues['Date From'], dateFormat).format(dateFormat),
        }
        : {},
      ...filterFormValues
        && filterFormValues['Date To']
        && !validate.date(filterFormValues['Date To'])
        && filterFormValues['Date From'] !== filterFormValues['Date To']
        ? {
          'Date of Creation To': moment(filterFormValues['Date To'], dateFormat).format(dateFormat),
        }
        : {},
      ...filterFormValues
        && filterFormValues['Date To']
        && !validate.date(filterFormValues['Date To'])
        && filterFormValues['Date From']
        && !validate.date(filterFormValues['Date From'])
        && filterFormValues['Date From'] === filterFormValues['Date To']
        ? {
          'Date of Creation': moment(filterFormValues['Date From'], dateFormat).format(dateFormat),
        }
        : {},
      ...filterFormValues
        && filterFormValues['User ID']
        ? {
          'User ID': filterFormValues['User ID'],
        }
        : {},
      ...filterFormValues
        && filterFormValues.Event
        && activityLogEventTypes.indexOf(filterFormValues.Event) !== -1
        ? {
          'Event': filterFormValues.Event,
        }
        : {},
      ...filterFormValues
        && filterFormValues['Order ID']
        ? {
          'Order ID': filterFormValues['Order ID'],
        }
        : {},
      ...(!filterFormValues && ownProps['Order ID'])
        || (filterFormValues && Object.keys(filterFormValues).length === 0 && ownProps['Order ID'])
        ? {
          'Order ID': ownProps['Order ID'].toString(),
        }
        : {}, 
    },
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchEventLog, clearEventLog }, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(EventLogViewDialog);



// WEBPACK FOOTER //
// ./src/components/patient/EventLogViewDialog/EventLogViewDialog.js